import { AuthContextProvider } from "./auth-context";

export default function ContextProviders(props) {
    return (
        <AuthContextProvider>
            {props.children}
        </AuthContextProvider>
    )
}
